import { Render } from 'src/utils/helper/render'

import FouAccordionItem from 'components/tools/fou-accordion/item.vue'
import MFPIcon from 'src/pages/bundle-submission/components/icons/mfp-icon/index.vue'
import FontPreviewer from 'src/pages/bundle-submission/components/font-previewer/FontPreviewer.vue'
import FouAccordion from 'components/tools/fou-accordion/index.vue'
import AnimationProcessing from 'components/animations/processing.vue'
import Plus from 'components/icons/plus/Plus.vue'
import { useStore } from 'vuex'
import TickIcon from '../icons/tick-icon/TickIcon.vue'
import { useRoute } from 'vue-router'
import { head, isEmpty, isEqual } from 'lodash'
import { ref, watch } from 'vue'
import FontStyleItem from '../font-style-item/FontStyleItem.vue'

export default {
  components:{
    FouAccordionItem,
    MFPIcon,
    FontPreviewer,
    FouAccordion,
    AnimationProcessing,
    Plus,
    TickIcon,
    FontStyleItem
  },
  props:{
    family: {
      type: Object,
      required: true
    }
  },

  setup(props, {emit}){

    function getFontRenderSrc({ md5, name, size = 20, color = '00000' }) {
      if (typeof md5 !== 'string') return null
      return md5.length
        ? Render.get({
          md5,
          name: encodeURI(name),
          size,
          fg: color
        })
        : null
    }

    const store = useStore()

    const route = useRoute()

    /* feature add fonts starts */
    async function addFontToBundle(fontBundleData) {
      fontBundleData.id = route?.params?.id
      return store.dispatch('bundle/addFontToBundle', fontBundleData)
    }
    /* feature add fonts ends */

    /* emit accordion click */
    const accordionItemRef = ref(null)

    watch(
      () => accordionItemRef.value?.isOpen,
      newValue => {
        if (newValue) {
          emit('accordionClick', props.family.familyId)
        }
      }
    )

    /**
 * Remove the add font tick icon when clicked again.
 */
    const updateAddFont = (fontData) => {
      emit('update:add-font', fontData)
    }

    /**
 * Custom package condition
 */
    const SINGLE_STYLE = 'singleStyle'

    function customPackageCondition(skus) {
      if(isEmpty(skus)) return false
      return skus.every(sku => sku.packageType !== 'singleType' && sku.packageType === 'customPackage')
    }

    return {
      store,
      route,
      props,
      accordionItemRef,
      head,
      isEmpty,
      isEqual,
      getFontRenderSrc,
      customPackageCondition,
      addFontToBundle,
      updateAddFont,
      SINGLE_STYLE
    }
  }
}
